// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-module--banner--3vxwK","form":"banner-module--form--3XaNl","title":"banner-module--title--NfXWV"};